var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookSquare = function SvgFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 1,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.114 12.313 13.47 10H11.25V8.5c0-.633.31-1.25 1.303-1.25h1.01V5.281s-.916-.156-1.791-.156c-1.828 0-3.022 1.108-3.022 3.113V10H6.719v2.313H8.75v5.59a8.044 8.044 0 0 0 2.5 0v-5.59h1.864Z",
    fill: "#000"
  })));
};
export default SvgFacebookSquare;